export default function DuplicateOverlay({ phase }) {
  if (!phase) return null

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-gray-900 border border-white/15 rounded-2xl px-10 py-8 flex flex-col items-center gap-4 shadow-2xl">
        {phase === 'loading' ? (
          <>
            <svg className="w-10 h-10 text-primary animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
            </svg>
            <p className="text-white font-medium text-base">Copie du quiz en cours…</p>
          </>
        ) : (
          <>
            <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
              <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-white font-medium text-base">Quiz copié !</p>
          </>
        )}
      </div>
    </div>
  )
}
